import { type FilterLayout, type TableColumn } from '@shared/ui/Table';
import { getFilterInputProps } from '@shared/ui/Table/filters';
import type { AllTexts } from '@/feature/lang/types';

export function getInputProps(
  column: TableColumn<any> | undefined,
  layout: FilterLayout | undefined,
  texts: AllTexts
) {
  return getFilterInputProps(column, layout, texts.shared.ui.table);
}
